declare global {
  interface Window {
    // action にはいくつかのkeywordが用意されているが、`identify` しか使わないので型は省略
    // https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-api
    clarity?: (action: string, ...args: unknown[]) => void;
  }
}

export const setClarityIdentify = (userId: number) => {
  if (typeof window.clarity === 'function') {
    // ClarityでCustom User IDとして登録される。ハッシュ化されて保存される。
    const customId = `${userId}`;
    // Clarityでハッシュ化された Custom User ID の代替表示名
    // これを指定しないと、Clarity上でハッシュ値が表示される。
    // 本来はClarityのポリシーとしてハッシュ値の元の値を表示名に使用することは好ましくない。
    // しかし、ユーザー行動から分析を行う際にUserIdを活用したいという要望を優先している。
    const friendlyName = `${userId}`;

    try {
      // https://learn.microsoft.com/en-us/clarity/setup-and-installation/identify-api#api-call
      window.clarity('identify', customId, null, null, friendlyName);
    } catch (error) {
      console.error('Clarity identify error:', error);
    }
  }
};
